import * as stylex from '@stylexjs/stylex'
import { Button, ButtonProps } from './ButtonComponent'
import {
  NextLinkWithEventPayload,
  type NextLinkWithEventPayloadProps,
} from '../NextLinkWithEventPayload'
import { forwardRef } from 'react'

interface LinkButtonProps
  extends ButtonProps,
    Pick<NextLinkWithEventPayloadProps, 'clickEventPayload'> {
  href?: string
}

export const LinkButton = forwardRef<HTMLAnchorElement, LinkButtonProps>(
  function LinkButton(
    { styles, href, clickEventPayload, children, ...props },
    ref
  ) {
    return (
      <Button
        asChild
        styles={[stylex.defaultMarker(), styles]}
        variant="link"
        iconRight={'arrow-right'}
        iconRightStyles={sx.iconStyles}
        hoverTrigger
        {...props}
      >
        <NextLinkWithEventPayload
          clickEventPayload={clickEventPayload}
          href={href!}
          ref={ref}
        >
          {children}
        </NextLinkWithEventPayload>
      </Button>
    )
  }
)

const sx = stylex.create({
  iconStyles: {
    transition: 'transform 0.2s ease-in-out',
    willChange: 'transform',
    transform: {
      default: 'none',
      [stylex.when.ancestor(':hover')]: 'translateX(8px)',
    },
  },
})
